import { load_many } from '@/store/action-helpers'
import axios from 'axios';

// noinspection JSUnusedGlobalSymbols
export default {

    loadAllByFileId: load_many('files/:fileId/links'),

    create({ dispatch }, { model }) {
        return axios.post('/api/v1/links', model).then(response => {
            return dispatch('loadAllByFileId', { fileId: model.file, force: true }).then(() => response)
        })
    },

    remove({ commit }, { model }) {
        return axios.delete(`/api/v1/links/${model.id}`).then(() => {
            return commit('REMOVE', { content: model })
        })
    },

}
